<template>
    <div v-show="visible"  @click="closeClick"  class="showPhoto">
      <!--  -->
      <!-- <div v-for="(item, index) in imageList" :key="item.activityImageId">
        <el-image
          :src="getImageUrl(item.imageUri)"
          :preview-src-list="previewSrcList"
          fit="cover"
          style='width: 100%; height: auto'
          :initial-index="imgIndex"
        />
      </div> -->
      <div v-if="imageList.length > 0">
        <el-image
          :src="getImageUrl(imageList[imgIndex].imageUri)"
          :preview-src-list="previewSrcList"
          fit="cover"
          :initial-index="imgIndex"
        />
      </div>

    </div>
  </template>
  <script>
  import { commonUtils } from "@/utils/common";
  export default {
    props: {
      url: {
        type: String,
        default: "",
      },
      visible: {
        type: Boolean,
        default: false,
      },
      imageList:{
        type:Array,
        default:[]
      },
      imgIndex:{
        type:Number,
        default:0
      }
    },
    computed: {
      previewSrcList() {
        return this.imageList.map(item => {
          return this.getImageUrl(item.imageUri)
        })
      }
    },
    created(){
      // console.log(this.imageList,'mounted-imageList');
      // console.log(this.imgIndex,'imgIndex=imgIndex');
    },
    watch:{
      'imgIndex': {
        handler (newV, oldV) {
          // console.log(newV,'newV');
          // console.log(oldV,'oldV');
          // this.imgIndex = newV
        },
        deep:true,
        immediate:true
        }
    },

    methods: {
      closeClick() {
        //子组件可以使用 $emit 触发父组件的自定义事件
        this.$emit("closeClick");
      },
      getImageUrl(uri) {
        if (!uri) return ''
        return commonUtils.getImageUrl(uri)
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  .showPhoto {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  </style>